import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ArrowRightIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M9.707 13.707l5-5a.999.999 0 0 0 0-1.414l-5-5a.999.999 0 1 0-1.414 1.414L11.586 7H2a1 1 0 0 0 0 2h9.586l-3.293 3.293a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0z"/></svg>
        )
    }
}

export default withCssClassName(ArrowRightIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/arrow-right-icon.js